import { FaSearch } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import "../commonStyle.css";
import {
  CAvatar,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UPDATE_REPORTEDBY_USER_LIST_FOR_POST } from "../../store/actionTypes";
import { debounce } from "lodash";
import CustomPagination from "../customPagination";
import { BsSortAlphaDown, BsSortAlphaDownAlt } from "react-icons/bs";
import { BsSortNumericDownAlt, BsSortNumericDown } from "react-icons/bs";
import { getPostReportedByAllUserList } from "../../views/reportManager/actions";
import CustomModal from "../customModal";
import DetailCard from "../siteDetailCard";
import DefaultProfilePic from "../../assets/images/DefaultProfilePic.jpg";
import { cilPeople } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { useNavigate } from "react-router-dom";
import {
  dateFormatter,
  getDateAndTimeFormatted,
} from "../../utils/commonFunctions";

/**
 * @function ReportedByUserTableForPost
 * @description for ReportedByUserTableForPost
 * @returns JSX for ReportedByUserTableForPost
 */

const ReportedByUserTableForPost = ({ selectedPostId }) => {
  const {
    dataList: usersList,
    pageNo,
    totalPage,
    limit,
    searchKey,
    isLoading,
    sortBy,
    sortOrder,
  } = useSelector((state) => state.ReportReducer.post.reportedByUsers);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState(searchKey);
  const [modal, setModal] = useState(false);
  const modalClose = () => {
    setModal(false);
  };

  const handlerSort = (sortBy) => {
    dispatch({
      type: UPDATE_REPORTEDBY_USER_LIST_FOR_POST,
      payload: { sortBy: sortBy, sortOrder: sortOrder === 1 ? -1 : 1 },
    });
  };

  const updatePage = (page) => {
    dispatch({
      type: UPDATE_REPORTEDBY_USER_LIST_FOR_POST,
      payload: { pageNo: page },
    });
  };

  const pageLimitHandler = (e) => {
    const currLimit = e?.target?.value;
    dispatch({
      type: UPDATE_REPORTEDBY_USER_LIST_FOR_POST,
      payload: { limit: currLimit, pageNo: 1 },
    });
  };

  const handleDebounceFn = (input) => {
    dispatch({
      type: UPDATE_REPORTEDBY_USER_LIST_FOR_POST,
      payload: { searchKey: input, pageNo: 1 },
    });
  };
  const deBounceFn = useMemo(() => debounce(handleDebounceFn, 500), []);

  const handleChange = (e) => {
    const text = e.target.value.replace(/[^a-zA-Z\s]/g, "").trimStart();
    setInputValue(text);
    if (text.length == 0 || text.length > 2) {
      deBounceFn(text);
    }
  };

  const handleClearInputField = () => {
    setInputValue("");
    deBounceFn("");
  };

  useEffect(() => {
    dispatch(getPostReportedByAllUserList(selectedPostId));
  }, [pageNo, totalPage, limit, searchKey, sortBy, sortOrder]);

  const renderTableBody = () => {
    return (
      <CTableBody>
        {usersList?.length > 0 &&
          usersList?.map((user, i) => {
            let userName =
              `${user?.userDetails?.firstName || ""} ${user?.userDetails?.lastName || ""}`.trim() ||
              "N/A";
            const status = user?.userDetails?.status || 3;
            if (status === 3) userName = "Deleted User";

            return (
              <CTableRow key={i} className="table-data-text">
                <CTableDataCell className="table-heading-10-cell">
                  <CAvatar
                    size="sm"
                    src={
                      user?.userDetails?.profileImage
                        ? user.userDetails.profileImage
                        : DefaultProfilePic
                    }
                    style={{ objectFit: "cover" }}
                    status={
                      status === 1
                        ? "success"
                        : status === 2
                          ? "warning"
                          : "danger"
                    }
                  />
                </CTableDataCell>
                <CTableDataCell
                  className={`table-heading-30-cell  ${status !== 3 ? "name-link" : ""} `}
                  onClick={
                    status !== 3
                      ? () => navigate(`/users/${user?.userId}`)
                      : undefined
                  }
                >
                  {userName}
                </CTableDataCell>
                <CTableDataCell className="table-heading-30-cell">
                  {user?.reason || "N/A"}
                </CTableDataCell>
                <CTableDataCell className="table-heading-30-cell">
                  {getDateAndTimeFormatted(user?.createdAt) || "N/A"}
                </CTableDataCell>
                <CustomModal
                  body={() => modalBody(user)}
                  confirmHandler={modalClose}
                  heading={"User Details"}
                  modalSize={"md"}
                  visible={modal}
                  visibleHandler={modalClose}
                  confirmText="Okay"
                  footershow={false}
                />
              </CTableRow>
            );
          })}
      </CTableBody>
    );
  };

  const renderPagination = () => {
    return (
      <CustomPagination
        limit={limit}
        limitHanlder={pageLimitHandler}
        pageNo={pageNo}
        pageChangeHanlder={updatePage}
        totalPage={totalPage}
      />
    );
  };

  const renderNoDataFound = () => {
    if (isLoading) {
      return (
        <div className="ndf-container">
          <h3 className="ndf-heading">
            <span>{" Fetching users "}</span> {"..."}
          </h3>
        </div>
      );
    }
    return (
      <div className="ndf-container">
        <h3 className="ndf-heading">
          {"No"}
          <span>{" Users "}</span> {"available !!!"}
        </h3>
      </div>
    );
  };

  const modalBody = (user) => {
    return (
      <div className="report--management--modal--body--container">
        <div className="site-data-container">
          <DetailCard
            data={
              user.userDetails?.firstName + " " + user.userDetails?.lastName ||
              "N/A"
            }
            label={"Full Name"}
          />
          <DetailCard data={user.reason || "N/A"} label={"Reason"} />
          <DetailCard
            data={dateFormatter(user.createdAt) || "N/A"}
            label={"Created At"}
          />
        </div>
      </div>
    );
  };

  const renderView = () => {
    return (
      <div>
        <div className="table-header-container">
          <h3 className="w-50 mb-0 text-primary  table-heading">
            {"Reported By User List"}
          </h3>
          <div className="d-flex justify-content-end align-items-center gap-1">
            {/* Search section */}
            <CInputGroup className="" style={{ width: "300px" }} size="sm">
              <CInputGroupText className="cursor-pointer">
                <FaSearch />
              </CInputGroupText>
              <CFormInput
                value={inputValue}
                name="text"
                onChange={handleChange}
                placeholder="Search user name"
              />
              {inputValue && (
                <CInputGroupText
                  className="cursor-pointer"
                  onClick={handleClearInputField}
                >
                  <RxCross2 />
                </CInputGroupText>
              )}
            </CInputGroup>
          </div>
        </div>
        <CTable hover responsive>
          <CTableHead className="text-nowrap border">
            <CTableRow className="table-heading-text">
              <CTableHeaderCell className="bg-body-tertiary table-heading-10-cell">
                <CIcon icon={cilPeople} />
              </CTableHeaderCell>
              <CTableHeaderCell className="bg-body-tertiary table-heading-30-cell">
                {"Full Name"}
                <span onClick={() => handlerSort("name")}>
                  {sortOrder === 1 ? (
                    <BsSortAlphaDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortAlphaDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>
              <CTableHeaderCell className="bg-body-tertiary table-heading-30-cell">
                {"Reason"}
              </CTableHeaderCell>
              <CTableHeaderCell className="bg-body-tertiary table-heading-30-cell">
                {"Reported At"}
                <span onClick={() => handlerSort("createdAt")}>
                  {sortOrder === 1 ? (
                    <BsSortNumericDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortNumericDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          {!isLoading && renderTableBody()}
        </CTable>
        {(usersList?.length >= 5 || pageNo > 1) && renderPagination()}
        {(isLoading || usersList?.length == 0) && renderNoDataFound()}
      </div>
    );
  };
  return <div className="rm-table-container">{renderView()}</div>;
};

export default ReportedByUserTableForPost;
